import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { LeftNavComponent } from './left-nav.component';

@NgModule({
    imports: [CommonModule,
        SharedModule, LeftNavComponent],
    exports: [LeftNavComponent],
    providers: [],
})
export class LeftNavModule {}
